import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedInput } from '../FormattedInput/FormattedInput';
/**
 * Standard social security number input composing the
 * standard NerdWallet formatted input component. This
 * variant of the SSN input only requires a user to provide
 * the last four digits of their SSN.
 *
 * There are some props that we don't allow the consumers
 * to override (like type) on the underlying Formatted (and
 * thus Input) component.
 *
 * InputSSNLastFour has an opinionated design, and some of those props
 * are not surfaced in InputSSNLastFour.propTypes.
 */

export var InputSSNLastFour = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var label = props.label,
      onChange = props.onChange,
      otherProps = _objectWithoutProperties(props, ["label", "onChange"]);

  return /*#__PURE__*/React.createElement(FormattedInput, _extends({}, otherProps, {
    format: "####",
    label: label,
    placeholder: "0000",
    type: "tel",
    small: true,
    ref: ref
  }));
});
InputSSNLastFour.displayName = 'InputSSNLastFour';
InputSSNLastFour.propTypes = {
  /**
   * The default label associated with
   * the input field. Should always be supplied
   * to meet accessibility best practices.
   */
  label: PropTypes.string,

  /**
   * Change handler required to access the
   * four SSN digits being supplied to the input component.
   */
  onChange: PropTypes.func
};
InputSSNLastFour.defaultProps = {
  label: 'Last 4 digits of SSN',
  onChange: function onChange() {}
};